import _definePage_default_0 from '/codebuild/output/src2089238516/src/onesimplekey-fe/src/pages/(account)/login.vue?definePage&vue&lang.tsx'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/codebuild/output/src2089238516/src/onesimplekey-fe/src/pages/(account)/resetPassword/index.vue?definePage&vue&lang.tsx'
import _definePage_default_3 from '/codebuild/output/src2089238516/src/onesimplekey-fe/src/pages/(account)/resetPassword/[code]/index.vue?definePage&vue&lang.tsx'

export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/codebuild/output/src2089238516/src/onesimplekey-fe/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/',
    /* internal name: '/(account)' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: 'login',
          name: '/(account)/login',
          component: () => import('/codebuild/output/src2089238516/src/onesimplekey-fe/src/pages/(account)/login.vue'),
          /* no children */
        },
        _definePage_default_0
      ),
      {
        path: 'resetPassword',
        /* internal name: '/(account)/resetPassword' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: '',
              name: '/(account)/resetPassword/',
              component: () => import('/codebuild/output/src2089238516/src/onesimplekey-fe/src/pages/(account)/resetPassword/index.vue'),
              /* no children */
            },
            _definePage_default_2
          ),
          {
            path: ':code',
            /* internal name: '/(account)/resetPassword/[code]' */
            /* no component */
            children: [
              _mergeRouteRecord(
                {
                  path: '',
                  name: '/(account)/resetPassword/[code]/',
                  component: () => import('/codebuild/output/src2089238516/src/onesimplekey-fe/src/pages/(account)/resetPassword/[code]/index.vue'),
                  /* no children */
                },
                _definePage_default_3
              )
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/404',
    name: '/404',
    component: () => import('/codebuild/output/src2089238516/src/onesimplekey-fe/src/pages/404.vue'),
    /* no children */
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

